import { Button } from '@material-ui/core';
import React, { ReactNode } from 'react';

export interface SecondaryButtonProps {
  'data-test'?: string;
  className?: string;
  title: ReactNode;
  onClick?: () => void | Promise<void>;
  disabled?: boolean;
  submit?: boolean;
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  title,
  className,
  onClick,
  disabled,
  submit,
  'data-test': dataTest,
}) => (
  <Button
    data-test={dataTest}
    className={className}
    variant="outlined"
    color="secondary"
    onClick={onClick}
    disabled={disabled}
    {...(submit ? { type: 'submit' } : {})}
  >
    {title}
  </Button>
);

export default SecondaryButton;
